// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__20XvE","header":"Messages_header__rEYz7"};